// extracted by mini-css-extract-plugin
export var beforeTitle = "Text-module--beforeTitle--2exOT";
export var title = "Text-module--title--1O2Rv";
export var content = "Text-module--content--rrFZE";
export var afterMore = "Text-module--afterMore--HHBMc";
export var large = "Text-module--large--v_Ncz";
export var collapsed = "Text-module--collapsed--36679";
export var more = "Text-module--more--265rV";
export var columns = "Text-module--columns--1TUum";